import { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import SplitPopover, { COST_TYPE_INFO } from "./SplitPopover";

export default function AssignmentCell({ expenseId, totalEur, currency = "EUR", splits, clients, services, onSave, onDelete, suggestion = null, onOpen }) {
  const [open, setOpen] = useState(false);

  // 3.3 — onOpen avisa al padre al abrir el popover (fetch perezoso de la
  // sugerencia de reparto); suggestion se reenvía tal cual a SplitPopover.
  const handleOpenChange = (o) => {
    setOpen(o);
    if (o) onOpen?.();
  };

  const costTypeLabel = (s) => {
    if (s.cost_type === "service_base") return "Base";
    if (s.cost_type === "operational") return "Operativo";
    if (s.cost_type === "own_investment") return "Inversión propia";
    if (s.cost_type === "client_direct") return clients.find(c => c.client_id === s.client_id)?.name || "?";
    return "?";
  };

  let label;
  if (splits.length === 0) {
    label = <span className="text-red-600 text-xs underline">Sin asignar</span>;
  } else if (splits.length === 1) {
    const s = splits[0];
    if (s.cost_type === "service_base") {
      label = <span className="text-purple-700 text-xs" title={COST_TYPE_INFO.service_base.description}>Base (todos)</span>;
    } else if (s.cost_type === "operational") {
      label = <span className="text-gray-600 text-xs" title={COST_TYPE_INFO.operational.description}>Operativo</span>;
    } else if (s.cost_type === "own_investment") {
      label = <span className="text-blue-600 text-xs" title={COST_TYPE_INFO.own_investment.description}>Inversión propia</span>;
    } else {
      const cliName = clients.find(c => c.client_id === s.client_id)?.name || "?";
      const svcName = services.find(sv => sv.service_id === s.service_id)?.service_name;
      label = <span className="text-green-700 text-xs">→ {cliName}{svcName ? ` · ${svcName}` : ""}</span>;
    }
  } else {
    const tooltip = splits.map(s => `${costTypeLabel(s)} ${s.amount_eur}€`).join(" · ");
    label = <span className="text-blue-600 text-xs" title={tooltip}>→ {splits.length} divisiones</span>;
  }

  return (
    <Popover open={open} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <button data-testid={`assignment-cell-${expenseId}`}>{label}</button>
      </PopoverTrigger>
      <PopoverContent align="end" className="p-0 w-[600px] max-w-[95vw]">
        <SplitPopover
          totalEur={totalEur}
          currency={currency}
          initialLines={splits}
          clients={clients}
          services={services}
          suggestion={suggestion}
          onSave={async (payload) => {
            await onSave(expenseId, payload);
            setOpen(false);
          }}
          onDelete={splits.length > 0 ? async () => {
            await onDelete(expenseId);
            setOpen(false);
          } : undefined}
          onCancel={() => setOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
}
